import { render, staticRenderFns } from "./SignupPageWithTitleSection.vue?vue&type=template&id=2119d84e&scoped=true&"
import script from "./SignupPageWithTitleSection.vue?vue&type=script&lang=ts&"
export * from "./SignupPageWithTitleSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119d84e",
  null
  
)

export default component.exports